module.exports = __webpack_public_path__ + "static/media/icon_phone.badef0e2.svg";